// import {
//   Component,
//   OnInit,
//   Input,
//   Output,
//   EventEmitter,
//   ViewEncapsulation,
// } from '@angular/core';
// import { MatSnackBar } from '@angular/material';

// @Component({
//   selector: 'mat-star-rating',
//   templateUrl: './star-rating.component.html',
//   styleUrls: ['./star-rating.component.scss'],
//   encapsulation: ViewEncapsulation.Emulated,
// })
// export class StarRatingComponent implements OnInit {
//   @Input('rating') private rating: number = 0;
//   @Input('type') private type:any
//   @Input('starCount') private starCount: number = 5;
//   @Input('color') private color: string = 'accent';
//   @Output() private ratingUpdated = new EventEmitter();

//   private snackBarDuration: number = 2000;
//   private ratingArr = [];
//   selectType:any;
//   constructor(private snackBar: MatSnackBar) {}

//   ngOnInit() {
//     console.log('a ' + this.starCount);
//     for (let index = 0; index < this.starCount; index++) {
//       this.ratingArr.push(index);
//     }
//   }
//   onClick(rating: number,type) {
//     this.selectType = type
//     this.snackBar.open('You rated ' + rating + ' / ' + this.starCount, '', {
//       duration: this.snackBarDuration,
//     });
//     this.ratingUpdated.emit(rating);
//     return false;
//   }

//   showIcon(index: number,) {
//     if (this.rating >= index + 1) {
//       return 'star';
//     } else {
//       return 'star_border';
//     }
//   }
// }
// export enum StarRatingColor {
//   primary = 'primary',
//   accent = 'accent',
//   warn = 'warn',
// }

import {
  Component,
  Input,
  forwardRef,
  ElementRef,
  Renderer2,
  AfterViewInit,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, FormBuilder } from "@angular/forms";

import { BaseControlValueAccessor } from "./BaseControlValueAccessor";

@Component({
  selector: "input-stars",
  templateUrl: "./star-rating.component.html",
  styleUrls: ["./star-rating.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StarRatingComponent),
      multi: true,
    },
  ],
})
export class StarRatingComponent
  extends BaseControlValueAccessor<any>
  implements AfterViewInit
{
  @Input() stars = [1, 2, 3, 4, 5]; // default is 5 stars
  @Input() messages: Array<string>; // optional text descriptors for each rating value
  @Input() label: string; // optional Label
  @Input() value: number = null; // un-touched value should be null
  displayText: string;
  disabled: boolean;
  ratingText: string;
  @Input() isDisable:boolean;

  constructor(
    private fb: FormBuilder,
    private eRef: ElementRef,
    private renderer: Renderer2
  ) {
    super();
    console.log(this.isDisable,'isdis')
  }

  writeValue(val) {
    this.value = val;
    super.writeValue(this.value);
  }

  setRating(rating) {
    if (this.disabled) {
      return;
    }
    // stars & messages arrays are 0 based
    console.log("Rating",rating);
    let oldVal = rating;
    this.value = rating;

    // set text to display (if it exists on the chosen star object)
    // this.ratingText = this.messages[rating] ? this.messages[rating] : undefined;

    // set the value for the control
    this.onChange(this.value);
    this.onTouched();

    // SVG STAR & DOM STUFF
    const svgs = this.eRef.nativeElement.querySelectorAll("img");
    console.log(svgs);
    for (let i = 0, j = svgs.length; i < j; i++) {
      if (i == rating-1) {
        this.renderer.addClass(svgs[i], "active_circle");
      } else {
        this.renderer.removeClass(svgs[i], "active_circle");
      }
    }
  }

  // if there's a value on init we need to apply it to the stars programatically
  // eRef has no DOM on init. We need to work with our view within AfterViewInit
  ngAfterViewInit() {
    if (this.value !== null) {
      let initialValue = this.value;
      this.setRating(--initialValue);
    }
  }
}
